import { useSearchParams } from "react-router";

import { VerifyEmailContent } from "@/modules/auth/components/verify-email-content";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token")?.trim() ?? null;

  return <VerifyEmailContent key={token ?? "missing"} token={token} />;
}
